import { useMediaQuery } from 'react-responsive';
import { useTheme } from '../context';

export const useIsMobile = () => {
  const { breakpoints } = useTheme();

  return useMediaQuery({ maxWidth: breakpoints.m });
};
